import { toast } from '@/components/hooks/use-toast';
import { FieldError } from 'react-hook-form';

const FieldErrorMessage = ({ message }: { message?: string | undefined }) => {
  return <li>{message}</li>;
};

interface ErrorToastProps {
  errors: Record<
    string,
    | FieldError
    | {
        message: string;
      }
  >;
}

export const ErrorToast = ({ errors }: ErrorToastProps) => {
  if (Object.keys(errors || {}).length === 0) return null;
  return toast({
    title: 'Error',
    description: (
      <ul>
        {Object.values(errors).map((error, idx) => {
          const { message } = error;
          return <FieldErrorMessage key={idx} message={message} />;
        })}
      </ul>
    ),
    variant: 'destructive',
  });
};
